import React, { Component } from 'react'
import { ResetPassword, Constants } from '@sukiai/components'
import { withRouter } from 'react-router-dom'
import { get } from 'lodash'
import { setToast } from '../lib/util'
import { resetPasswordEmailOnly } from '../rest'
import { ROUTES } from '../lib'

const { TOAST } = Constants
class ResetPasswordContainer extends Component {
  state = {
    isLoading: false
  }

  onSubmit = email => {
    const { history } = this.props

    this.setState({ isLoading: true })
    resetPasswordEmailOnly(email)
      .then(({ status }) => {
        // setToast
        // redirect to root (login)
        setToast(TOAST.TYPE.PRIMARY, 'If the supplied email address is valid, you should receive an email shortly with instructions on resetting your password. If you did not receive an email and still require assistance, please contact support@suki.ai', 5000)

        this.setState({ isLoading: true })
        history.push(ROUTES.ROOT)
      })
  }

  render () {
    const { isLoading } = this.state
    const username = get(this.props, 'location.state.username', '')
    return (
      <ResetPassword
        username={username}
        handleSubmit={this.onSubmit}
        isLoading={isLoading}
      />

    )
  }
}

export default withRouter(ResetPasswordContainer)
